module.exports = __webpack_public_path__ + "img/portrait_1280.f65d7dd9.jpg";